import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { exportParameters } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';


export const useEditExportParameters = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    async ({ partnerAccountID, parameters }) => axiosInstance.put(
      exportParameters(orgId).edit(partnerAccountID),
      {
        organizationID: orgId,
        partnerAccountID,
        parameters,
      },
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['ExportParameters', orgId] });
        dispatch(showAlert({ message: 'Export parameters updated successfully.', type: 'success' }));
      },
      onError: (err) => {
        dispatch(showAlert({
          message: err.response?.data?.message || 'Failed to update export parameters.',
          type: 'error',
        }));
      },
    },
  );
};
